(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("shared", [], factory);
	else if(typeof exports === 'object')
		exports["shared"] = factory();
	else
		root["shared"] = factory();
})(window, function() {
return 